var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8 6.154a2.05 2.05 0 0 1 .67 3.338L4.498 25.54a2.04 2.04 0 0 1-1.453.602 2.03 2.03 0 0 1-1.444-.596A2.036 2.036 0 0 1 1 24.099a2.033 2.033 0 0 1 .597-1.448l15.97-16.047A2.026 2.026 0 0 1 19.012 6h.005c.269 0 .534.052.782.154zm8.75-.076c.398-.08.81-.04 1.185.117A2.04 2.04 0 0 1 31 8.088v16.047a2.05 2.05 0 0 1-3.495 1.447 2.05 2.05 0 0 1-.6-1.447V13.048l-12.47 12.53a2.05 2.05 0 0 1-2.897.009 2.05 2.05 0 0 1-.007-2.896L27.504 6.644c.285-.289.65-.485 1.047-.565z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPond);
export default __webpack_public_path__ + "static/media/POND.6405c5c849a561acf364ff0e293c2c9f.svg";
export { ForwardRef as ReactComponent };